"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Client = void 0;

var events_1 = require("events");

var twilsock_1 = require("twilsock");

var configuration_1 = require("./configuration");

var registrar_1 = require("./registrar");

var logger_1 = require("./logger");
/**
 * @class
 * @alias Notifications
 * @classdesc The helper library for the notification service.
 * Provides high level api for creating and managing notification subscriptions and receiving messages
 * Creates the instance of Notification helper library
 *
 * @constructor
 * @param {string} token - Twilio access token
 * @param {Notifications#ClientOptions} options - Options to customize client behavior
 */


var Client = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(Client, _events_1$EventEmitte);

  var _super = _createSuper(Client);

  function Client(token) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Client);

    _this = _super.call(this);

    if (!token || token.length === 0) {
      throw new Error('Token is required for Notifications client');
    }

    options.logLevel = options.logLevel || 'error';
    logger_1.log.setLevel(options.logLevel);
    var minTokenRefreshInterval = options.minTokenRefreshInterval || 10000;
    var productId = options.productId || 'notifications';
    options.twilsockClient = options.twilsockClient || new twilsock_1.TwilsockClient(token, productId, options);
    options.transport = options.transport || options.twilsockClient;
    _this.services = {
      twilsock: options.twilsockClient,
      transport: options.transport,
      config: new configuration_1.Configuration(null, options)
    };
    _this.registrar = new registrar_1.Registrar(productId, _this.services.transport, _this.services.twilsock, _this.services.config);
    _this.reliableTransportState = {
      overall: false,
      transport: false,
      registration: false,
      lastEmitted: null
    };

    _this._onTransportStateChange(_this.services.twilsock.isConnected);

    _this.registrar.on('transportReady', function (state) {
      _this._onRegistrationStateChange(state ? 'registered' : '');
    });

    _this.registrar.on('stateChanged', function (state) {
      _this._onRegistrationStateChange(state);
    });

    _this.registrar.on('needReliableTransport', _this._onNeedReliableTransport.bind(_assertThisInitialized(_this)));

    _this.services.twilsock.on('message', function (type, message) {
      return _this._routeMessage(type, message);
    });

    _this.services.twilsock.on('connected', function (notificationId) {
      _this._onTransportStateChange(true);

      _this.registrar.setNotificationId('twilsock', notificationId);
    });

    _this.services.twilsock.on('disconnected', function () {
      _this._onTransportStateChange(false);
    });

    _this.services.config.updateToken(token);

    _this.registrar.updateToken(token);

    return _this;
  }

  _createClass(Client, [{
    key: "connectionState",
    get: function get() {
      if (this.services.twilsock.state === 'disconnected') {
        return 'disconnected';
      } else if (this.services.twilsock.state === 'disconnecting') {
        return 'disconnecting';
      } else if (this.services.twilsock.state === 'connected' && this.reliableTransportState.registration) {
        return 'connected';
      } else if (this.services.twilsock.state === 'rejected') {
        return 'denied';
      }

      return 'connecting';
    }
    /**
     * Routes messages to the external subscribers
     * @private
     */

  }, {
    key: "_routeMessage",
    value: function _routeMessage(type, message) {
      logger_1.log.trace('Message arrived: ', type, message);
      this.emit('message', type, message);
    }
  }, {
    key: "_onNeedReliableTransport",
    value: function _onNeedReliableTransport(isNeeded) {
      if (isNeeded) {
        this.services.twilsock.connect();
      } else {
        this.services.twilsock.disconnect();
      }
    }
  }, {
    key: "_onRegistrationStateChange",
    value: function _onRegistrationStateChange(state) {
      this.reliableTransportState.registration = state === 'registered';

      this._updateTransportState();
    }
  }, {
    key: "_onTransportStateChange",
    value: function _onTransportStateChange(connected) {
      this.reliableTransportState.transport = connected;

      this._updateTransportState();
    }
  }, {
    key: "_updateTransportState",
    value: function _updateTransportState() {
      var overallState = this.reliableTransportState.transport && this.reliableTransportState.registration;

      if (this.reliableTransportState.overall !== overallState) {
        this.reliableTransportState.overall = overallState;
        logger_1.log.info('Transport ready:', overallState);
        this.emit('transportReady', overallState);
      }

      if (this.reliableTransportState.lastEmitted !== this.connectionState) {
        this.reliableTransportState.lastEmitted = this.connectionState;
        this.emit('connectionStateChanged', this.connectionState);
      }
    }
    /**
     * Adds the subscription for the given message type
     * @param {string} messageType The type of message that you want to receive
     * @param {string} channelType. Supported are 'twilsock', 'gcm' and 'fcm'
     */

  }, {
    key: "subscribe",
    value: function subscribe(messageType) {
      var channelType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'twilsock';
      logger_1.log.trace('Add subscriptions for message type: ', messageType, channelType);
      return this.registrar.subscribe(messageType, channelType);
    }
    /**
     * Remove the subscription for the particular message type
     * @param {string} messageType The type of message that you don't want to receive anymore
     * @param {string} channelType. Supported are 'twilsock', 'gcm' and 'fcm'
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(messageType) {
      var channelType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'twilsock';
      logger_1.log.trace('Remove subscriptions for message type: ', messageType, channelType);
      return this.registrar.unsubscribe(messageType, channelType);
    }
    /**
     * Handle incoming push notification.
     * Client application should call this method when it receives push notifications and pass the received data
     * @param {Object} message push message
     * @return {PushNotification}
     */

  }, {
    key: "handlePushNotification",
    value: function handlePushNotification(message) {
      return {
        messageType: message.twi_message_type,
        payload: message.payload
      };
    }
    /**
     * Set APN/GCM/FCM token to enable application register for a push messages
     * @param {string} gcmToken/fcmToken Token received from GCM/FCM system
     */

  }, {
    key: "setPushRegistrationId",
    value: function setPushRegistrationId(registrationId, channelType) {
      logger_1.log.trace('Set push registration id', registrationId, channelType);
      this.registrar.setNotificationId(channelType, registrationId);
    }
    /**
     * Updates auth token for registration
     * @param {string} token Authentication token for registrations
     */

  }, {
    key: "updateToken",
    value: function () {
      var _updateToken = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(token) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger_1.log.info('authTokenUpdated');

                if (!(this.services.config.token === token)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return this.services.twilsock.updateToken(token);

              case 5:
                this.services.config.updateToken(token);
                this.registrar.updateToken(token);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateToken(_x) {
        return _updateToken.apply(this, arguments);
      }

      return updateToken;
    }()
  }]);

  return Client;
}(events_1.EventEmitter);

exports.Client = Client;
/**
 * Fired when new message arrived.
 * @param {Object} message`
 * @event Client#message
 */

/**
 * Fired when transport state has changed
 * @param {boolean} transport state
 * @event Client#transportReady
 */

/**
 * Fired when transport state has been changed
 * @param {string} transport state
 * @event Client#connectionStateChanged
 */

/**
 * These options can be passed to Client constructor
 * @typedef {Object} Notifications#ClientOptions
 * @property {String} [logLevel='error'] - The level of logging to enable. Valid options
 *   (from strictest to broadest): ['silent', 'error', 'warn', 'info', 'debug', 'trace']
 */